import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, greys, palette } from "@clockwise/web-commons/src/styles/color.styles";
import { onboardingSurvey } from "@img/illustrations";
export {
  flatButton,
  flatButtonIcon,
  primaryButton,
  primaryButtonIcon,
} from "../OnboardingCommon.styles";

export const container: CSSProperties = {
  flex: 1,
  overflowY: "scroll",
  padding: "75px 40px 20px",
  backgroundImage: `url(${onboardingSurvey})`,
  backgroundPosition: "right 100px bottom 53px",
  backgroundRepeat: "no-repeat",
};

export const H1: CSSProperties = {
  margin: 0,
  fontSize: 24,
  color: colors.blueDusk.standard,
  paddingBottom: 25,
  paddingTop: 0,
};

export const greenText: CSSProperties = {
  color: colors.green.standard,
};

export const description: CSSProperties = {
  color: palette.slate,
  fontSize: 16,
  marginBottom: 15,
};

export const question = {
  container: {
    color: palette.slate,
    fontSize: 16,
    padding: "15px 0",
    width: 450,
  } as CSSProperties,
};

export const btnContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: 20,
  borderWidth: "1px 0 0 0",
  borderColor: greys.borderGrey,
  borderStyle: "solid",
  userSelect: "none",
};
